import * as React from "react";

function SvgCandu(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M160.874 130.695v56a8.42 8.42 0 008.42 8.42h21.66c4.95 0 8.88-4.26 8.39-9.19-2.84-28.14-18.5-50.53-38.47-55.23z"
        fill="#FE8A3A"
      />
      <path
        d="M89.474 195.115h44.33a8.42 8.42 0 008.42-8.42v-93.22c-32.82 7.73-58.29 45.73-61.16 92.76-.29 4.82 3.59 8.88 8.41 8.88z"
        fill="#EE4266"
      />
      <path
        d="M253.984 180.045c-12.55-5.87-27.62.21-33.55 12.72a90.096 90.096 0 01-7.44 12.86c-3.71 5.34-9.83 8.49-16.33 8.49h-114.3c-6.46 0-12.56-3.1-16.26-8.39-8.26-11.79-13.57-25.49-15.39-40.18-2.95-23.72 3.52-47.17 18.21-66.03 14.69-18.86 35.84-30.86 59.57-33.81 19.41-2.41 38.61 1.44 55.51 11.15 16.19 9.29 29.3 23.67 36.98 40.54 5.73 12.58 20.69 18.88 33.31 13.24 12.59-5.63 18.25-20.41 12.62-33.01-11.92-26.72-32.53-49.5-58.02-64.13-26.38-15.15-56.32-21.16-86.57-17.41-36.98 4.59-69.95 23.31-92.85 52.7-22.9 29.39-32.98 65.94-28.39 102.92 4.59 36.98 23.31 69.95 52.7 92.85 24.75 19.28 54.57 29.47 85.44 29.47 5.79 0 11.63-.36 17.48-1.09 48.04-5.97 88.93-35.77 109.36-79.71 5.81-12.5.4-27.34-12.08-33.18z"
        fill="#6310E5"
      />
    </svg>
  );
}

export default React.forwardRef(SvgCandu);
